export var fontSize = '0.875rem'; // eslint-disable-line